module.exports = __webpack_public_path__ + "static/media/uploadedFile.18927083.svg";